import { render, staticRenderFns } from "./doctorProfileSummaryDetails.vue?vue&type=template&id=a02237fa&"
import script from "./doctorProfileSummaryDetails.vue?vue&type=script&lang=js&"
export * from "./doctorProfileSummaryDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports